import { PortableText, type PortableTextBlock } from '@portabletext/react'

const portableTextComponents = {
  marks: {
    link: ({ value, children }: { value?: { href?: string }; children?: React.ReactNode }) => (
      <a
        href={value?.href}
        target="_blank"
        rel="noopener"
        className="ap:text-content-link ap:hover:text-content-link-hover ap:hover:underline"
      >
        {children}
      </a>
    ),
  },
  block: {
    normal: ({ children }: { children?: React.ReactNode }) => (
      <p className="ap:text-sm ap:leading-relaxed ap:text-content-secondary ap:mb-md">{children}</p>
    ),
    h3: ({ children }: { children?: React.ReactNode }) => (
      <h3 className="ap:text-base ap:font-semibold ap:mt-lg ap:mb-xs">{children}</h3>
    ),
    h4: ({ children }: { children?: React.ReactNode }) => (
      <h4 className="ap:text-sm ap:font-semibold ap:mt-md ap:mb-xs">{children}</h4>
    ),
  },
  list: {
    bullet: ({ children }: { children?: React.ReactNode }) => (
      <ul className="ap:list-disc ap:list-inside ap:mb-md ap:space-y-xs ap:text-sm ap:text-content-secondary">
        {children}
      </ul>
    ),
    number: ({ children }: { children?: React.ReactNode }) => (
      <ol className="ap:list-decimal ap:list-inside ap:mb-md ap:space-y-xs ap:text-sm ap:text-content-secondary">
        {children}
      </ol>
    ),
  },
}

export const FaqAnswer = ({ answer }: { answer?: unknown[] | null }) => {
  if (!Array.isArray(answer)) return null

  return <PortableText value={answer as PortableTextBlock[]} components={portableTextComponents} />
}
